var _defs, _rect, _rect2, _rect3, _g, _g2, _rect4, _text, _rect5, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasR124A3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9efe6"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 36,
    height: 36,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 L 0 0 0 36",
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.13,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 816,
    height: 816,
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 460) scale(0.76)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gasBody",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2E8B57",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2E8B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0.42
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-118,-118 a118,118 0 0 1 236,0 L118,196 a30,30 0 0 1 -30,30 L-88,226 a30,30 0 0 1 -30,-30 Z",
    fill: "url(#gasBody)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118,-118 a118,118 0 0 1 236,0 L118,196 a30,30 0 0 1 -30,30 L-88,226 a30,30 0 0 1 -30,-30 Z",
    fill: "#000",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-118,-118 a118,118 0 0 1 236,0 L118,196 a30,30 0 0 1 -30,30 L-88,226 a30,30 0 0 1 -30,-30 Z",
    fill: "url(#gasBody)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96,
    y: -142,
    width: 66,
    height: 330,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -118,
    y: -34,
    width: 236,
    height: 150,
    fill: "#f7faf7",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: -118,
    y: -34,
    width: 236,
    height: 12,
    fill: "#2E8B57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -118,
    y: 104,
    width: 236,
    height: 12,
    fill: "#2E8B57"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 42,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 74,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 1.48
  }, "R-124A"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 84,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 1.32
  }, "HCFC REFRIGERANT"), /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: -206,
    width: 144,
    height: 60,
    rx: 16,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -262,
    width: 52,
    height: 70,
    rx: 12,
    fill: "url(#brass)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -272,
    r: 34,
    fill: "url(#brass)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -272,
    r: 13,
    fill: "#6d5a17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-206 a52,52 0 0 1 104,0",
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 14
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#628141",
    strokeWidth: 2,
    strokeOpacity: 0.7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 732 h560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 220 v420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 220 h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 640 h20"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 716,
    width: 140,
    height: 32,
    rx: 6,
    fill: "#fbfdfa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 739,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 1.6
  }, "10 KG")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 76,
    height: 40,
    fill: "#1B211A"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 69,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 19,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 2.28
  }, "SRF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 0.5,
    textAnchor: "start",
    letterSpacing: 0.96
  }, "R-124A Refrigerant \u2014 TECHNICAL VIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasR124A3);
export default __webpack_public_path__ + "static/media/gas-r124a-3.176cad8340c0d541cdb80e6b2b3e4219.svg";
export { ForwardRef as ReactComponent };